import { default as getFavouriteStatus } from "@pb/utils/getFavouriteStatus";
import { isOtherStoriesBrand } from "@pb/utils/brandConfig";
import { isHmBrand } from "@pb/utils/brandConfig";
import { default as isEmpty } from "@pb/utils/isEmpty";
const formatProductMarker = (product) => {
    var _a;
    if (!isHmBrand) {
        if (product.productMarkerText) {
            return {
                text: product.productMarkerText,
            };
        }
    }
    // NOTE: supporting only single marker for H&M at the moment.
    if ((_a = product.markers) === null || _a === void 0 ? void 0 : _a.length)
        return product.markers[0];
    return {};
};
const mapE3Product = (product, disableFavorites, dataLabels) => {
    var _a, _b, _c;
    const variantData = (product.variantData && product.variantData[0]) || {};
    const isNewProduct = !isOtherStoriesBrand && product.isNew === 'true';
    const productCategory = (_c = (_b = (_a = product.categoryId) === null || _a === void 0 ? void 0 : _a.split('/')) === null || _b === void 0 ? void 0 : _b.pop()) === null || _c === void 0 ? void 0 : _c.toUpperCase();
    const productMarkers = formatProductMarker(product);
    const mappedProductRootData = Object.assign(Object.assign(Object.assign({ imageModelSrc: '', imageModelAlt: product.productName || '', imageProductAlt: product.productName || '', title: product.productName || '', isNewProduct, showFavoriteButton: !disableFavorites, showEnergyButton: false, brandName: product.brandName || '', isOutOfStock: undefined, category: productCategory, hasPriceMarker: false, isExternalBrand: product.external === 'true', trackingInfo: {
            ticketId: product.ticket,
        } }, (isNewProduct && dataLabels.newArrival && { newProductLabel: dataLabels.newArrival })), (!isEmpty(productMarkers) && {
        markers: [productMarkers],
    })), (dataLabels.priorPriceLabel && { priorPriceLabel: dataLabels.priorPriceLabel }));
    const formatPriceValue = (originalPrice) => {
        if (!originalPrice) {
            return null;
        }
        const justNumbers = originalPrice.match(/\d+/g);
        if (justNumbers === null || justNumbers === void 0 ? void 0 : justNumbers.length) {
            if (justNumbers.length > 1) {
                return justNumbers.join(',');
            }
            return `${justNumbers[0]},00`;
        }
        return null;
    };
    const regPriceValue = variantData.vprice || formatPriceValue(variantData.vformattedPrice);
    const oldPriceValue = variantData.voldPrice || formatPriceValue(variantData.vformattedOldPrice);
    const mappedProductVariantData = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ initialFavouriteStatus: getFavouriteStatus(variantData.varticleCode || ''), imageProductSrc: variantData.vstillLifeImage || '', articleCode: variantData.varticleCode || '', pdpUrl: variantData.vlinkPdp || '', yellowPrice: variantData.vformattedYellowprice || '', regularPrice: variantData.vformattedOldPrice || variantData.vformattedPrice, regularPriceValue: oldPriceValue || regPriceValue || '', alternateColor: {
            code: variantData.vhybrisColorCode,
        } }, (variantData.vcomparativeQuantity &&
        variantData.vcomparativeFormattedPrice &&
        variantData.vquantity && {
        comparativePrice: {
            comparativeQuantity: variantData.vcomparativeQuantity,
            formattedPrice: variantData.vcomparativeFormattedPrice,
            quantity: variantData.vquantity,
        },
    })), (variantData.vformattedYellowprice &&
        dataLabels.clubMemberPrice && { clubPriceLabel: dataLabels.clubMemberPrice })), (variantData.vformattedBlueprice && { bluePrice: variantData.vformattedBlueprice })), (variantData.vformattedOldPrice && { redPrice: variantData.vformattedPrice })), (variantData.vformattedOldPrice && { redPriceValue: regPriceValue || '' })), (variantData.vatelierName && { atelierName: variantData.vatelierName })), (variantData.vcolorLoc && { variantColor: variantData.vcolorLoc })), (variantData.vformattedPriorPrice && { priorPrice: variantData.vformattedPriorPrice }));
    const otherStoriesSpecificDetails = {
        isPriceBelowProductMarkers: true,
        showRedPriceFirst: false,
        isMarkersAboveProductName: false,
    };
    return Object.assign(Object.assign(Object.assign({}, mappedProductRootData), mappedProductVariantData), (isOtherStoriesBrand && otherStoriesSpecificDetails));
};
export default mapE3Product;
//# sourceMappingURL=mapE3Product.js.map